/* eslint-disable security/detect-object-injection */
import LockIcon from '@mui/icons-material/Lock'
import NoEncryptionIcon from '@mui/icons-material/NoEncryption'
import { Chip } from '@mui/material'
import { FC } from 'react'
import { useTranslate } from 'react-admin'

type PrivilegeType = 'VT' | 'BT' | 'INITIATOR'

interface AccessPrivilegeChipProps {
  privilege: PrivilegeType
}

const AccessPrivilegeChip: FC<AccessPrivilegeChipProps> = ({ privilege }) => {
  const translate = useTranslate()

  const labelMap: Record<PrivilegeType, string> = {
    VT: translate('data.privilegeVT'),
    BT: translate('data.privilege'),
    INITIATOR: translate('data.privilegeInitiator'),
  }

  const colorMap: Record<PrivilegeType, 'success' | 'warning' | 'info'> = {
    VT: 'success',
    BT: 'warning',
    INITIATOR: 'info',
  }

  const iconMap: Record<PrivilegeType, JSX.Element> = {
    VT: <NoEncryptionIcon fontSize="small" />,
    BT: <LockIcon fontSize="small" />,
    INITIATOR: <NoEncryptionIcon fontSize="small" />,
  }

  return (
    <Chip
      label={labelMap[privilege]}
      color={colorMap[privilege]}
      icon={iconMap[privilege]}
      variant="outlined"
      size="small"
    />
  )
}

export default AccessPrivilegeChip
